import("../../../assets/js/splide.js")
	.then(({ Splide }) => {
		// Variables
		const sliders = document.querySelectorAll(".content-gallery-carousel .splide")

		// Initializing Splider
		for (let i = 0; i < sliders.length; i++) {
			const splide = new Splide(sliders[i], {
				accessibility: true,
				keyboard: "focused",
				type: "fade",
				rewind: true,
                arrows: true,
				pagination: false,
				perPage: 1,
				reducedMotion: {
					speed: 0,
					rewindSpeed: 0,
				}
			}).mount()

            // Remove non-standard aria-roledescription from region (role="region" is sufficient)
            sliders[i].removeAttribute('aria-roledescription');

            // Remove aria-live + orphaned aria-atomic from track since our counter handles announcements
            const track = sliders[i].querySelector('.splide__track');
            track?.removeAttribute('aria-live');
            track?.removeAttribute('aria-atomic');

			// Slide counter
			const block = sliders[i].closest(".content-gallery-carousel")
			const counter = block?.querySelector(".gallery-slide-counter")
			if (counter) {
				const total = splide.length
				const update = (index) => {
					counter.textContent = `${index + 1} of ${total}`
				}
				update(splide.index)
				splide.on("move", (newIndex) => update(newIndex))
			}
		}
	})
	.catch((err) => {
		console.error(err)
	});

// Cursor-following arrows
const galleryBlocks = document.querySelectorAll(".content-gallery-carousel")

galleryBlocks.forEach((block) => {
	const leftArrow = block.querySelector(".cursor-left-arrow")
	const rightArrow = block.querySelector(".cursor-right-arrow")
	const prevBtn = block.querySelector(".splide__arrow--prev")
	const nextBtn = block.querySelector(".splide__arrow--next")

	if (!leftArrow || !rightArrow) return

	block.addEventListener("mousemove", (e) => {
		const x = e.clientX
		const y = e.clientY
		leftArrow.style.transform = `translate(calc(${x}px - 50%), calc(${y}px - 50%))`
		rightArrow.style.transform = `translate(calc(${x}px - 50%), calc(${y}px - 50%))`
	})

	block.addEventListener("mouseleave", () => {
		leftArrow.style.opacity = "0"
		rightArrow.style.opacity = "0"
	})

	prevBtn?.addEventListener("mouseenter", () => {
		leftArrow.style.opacity = "1"
	})
	prevBtn?.addEventListener("mouseleave", () => {
		leftArrow.style.opacity = "0"
	})

	nextBtn?.addEventListener("mouseenter", () => {
		rightArrow.style.opacity = "1"
	})
	nextBtn?.addEventListener("mouseleave", () => {
		rightArrow.style.opacity = "0"
	})
})

Promise.all([import('gsap'), import('gsap/ScrollTrigger')])
	.then(([{ gsap }, { ScrollTrigger }]) => {
		gsap.registerPlugin(ScrollTrigger);
		
		// Function to check if motion should be reduced
		const shouldReduceMotion = () => {
			// Check system preference
			const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
			// Check custom accessibility widget class
			const widgetReduceMotion = document.documentElement.classList.contains('reduce-motion');
			return prefersReducedMotion || widgetReduceMotion;
		};
		
		// Only run animation on screens wider than 1023px AND if user hasn't requested reduced motion
		const mm = gsap.matchMedia();
		
		mm.add("(min-width: 1024px)", () => {
			document.querySelectorAll('.content-gallery-carousel').forEach(wrapper => {
				try {
					// Ensure we're only working with elements in the main document (not iframes)
					if (wrapper.ownerDocument !== document) return;
					if (wrapper.classList.contains('no-animate')) {
						gsap.set(wrapper.querySelector('section > div'), { clipPath: 'none' });
						return;
					}
					
					// Target the main content container that includes both text and gallery
					const blockContent = wrapper.querySelector('section > div');
					
					if (!blockContent) return;
					
					// If user prefers reduced motion, skip animation and ensure content is visible
					if (shouldReduceMotion()) {
						gsap.set(blockContent, { clipPath: 'none' });
						return;
					}
					
					// Set initial state: circle mask at 0% from bottom center (fully hidden)
					gsap.set(blockContent, { 
						clipPath: 'circle(25% at 50% 100%)',
					});
					
					// Animate the circle expanding from bottom to reveal content
					const animation = gsap.to(blockContent, {
						clipPath: 'circle(100% at 50% 100%)', // Expand to 150% to fully reveal
						scrollTrigger: {
							trigger: wrapper,
							start: '50% bottom',      // Start when block enters viewport
							end: '120% bottom',           // End when block is 30% from top
							scrub: 1,                 // Smooth scrubbing
							invalidateOnRefresh: true,
							markers: false,           // Set to true for debugging
						},
					});
					
					// Listen for accessibility widget changes
					const observer = new MutationObserver(() => {
						if (document.documentElement.classList.contains('reduce-motion')) {
							// Kill animation and show content
							animation.scrollTrigger?.kill();
							animation.kill();
							gsap.set(blockContent, { clipPath: 'none' });
						}
					});
					
					observer.observe(document.documentElement, {
						attributes: true,
						attributeFilter: ['class']
					});
				} catch(error) {
					// Silently handle cross-origin or permission errors without breaking the page
					console.warn('ScrollTrigger initialization skipped for element:', error.message);
				}
			});
		});
	})
	.catch(console.error);